<template>
    <div>
        <!-- stage one of post aNewItem -->
        <div class="container">
            <div class="row my-3">
                <div class="col-4">
                    <div class="progress">
                        <div class="progress-bar bg-dark-green" role="progessbar" style="width: 100%">1/3</div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="progress">
                        <div class="progress-bar bg-grey text-dark-green" role="progessbar" style="width: 100%">2/3</div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="progress">
                        <div class="progress-bar bg-grey text-dark-green" role="progessbar" style="width: 100%">3/3</div>
                    </div>
                </div>
            </div>
            <!-- Alert Messages -->
            <dl v-if="msg !== ''" class="row mt-3 mb-n3">
                <dd class="col-12">
                    <div :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                        <i class="fas fa-exclamation-circle"></i> {{ msg }}
                    </div>
                </dd>
            </dl>
            <form enctype="multipart/form-data">
                <!-- stage heading -->
                <div class="row mt-5">
                    <div class="col-md-8 col-sm-6 col-12">
                        <h3 class="small-text">Upload Item Photos</h3>
                    </div>
                    <div class="col-md-4 col-sm-6 col-12">
                        <div class="row">
                            <div class="col-6">
                                <span @click.prevent="cancelPosting" class="btn btn-light btn-sm h3 form-control">Cancel</span>
                            </div>
                            <div class="col-6">
                                <button @click.prevent="gotoStage2" class="btn btn-dark-green btn-sm h3 form-control">Next &gt;&gt;</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- select image -->
                <div class="row">
                    <div class="col-12">
                        <div class="card text-center text-muted">
                            <div class="card-body pt-5 pb-0 item-upload">
                                <label for="file-input">
                                    <i class="far fa-plus-square fa-10x clickable"></i>
                                </label>
                                <input @change="uploadProceed" type="file" multiple accept="image/jpeg, image/png, image/gif" hidden id="file-input"/>
                            </div>
                            <p class="py-2">Select all photos of the item at once!</p>
                        </div>
                    </div>
                </div>
            </form>
            <!-- preview images -->
            <div class="row my-3">
                <div class="col-12">
                    <div class="card text-center text-muted">
                        <div class="card-body p-0 form-inline mx-auto">
                            <div v-for="(x,i) in previewArrCheck" :key="i" class="mx-1 preview-box">
                                <template v-if="previewArr.length > 0">
                                    <img @click="mainPhoto(i)" :src="x.path" class="rounded preview-img" />
                                    <small v-if="x.main" class="preview-default">
                                        <p class="my-0 text-light font-weight-bold">main</p>
                                    </small>
                                    <i @click="removePhoto(i)" class="fas fa-trash-alt p-1 preview-trash rounded text-danger"></i>
                                </template>
                                <i v-else class="far fa-image fa-3x"></i>
                            </div>
                        </div>
                        <div class="card-footer p-0">
                            Total photos uploaded: {{photosArr.length}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'

export default {
    name: "StageOne",
    data() {
        return {
            previewArr: [],
            photosArr: [],
            previewImg: '',
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(['photosPreview', 'buildNewItemObj', 'footerFixed', 'destroyNewItemObj']),
        gotoStage2() {
            this.color = "danger"
            if(this.photosArr.length === 0){ this.msg = "Upload at least one photo of your item"; return }
            // add properties to build aNewItem object 
            let newItemObj = {
                photos: this.photosArr
            }
            // temp. save the image previews on store 
            this.photosPreview(this.previewArr).then(() => {}).catch((e) => {})
            this.buildNewItemObj(newItemObj)
            .then(() => {
                this.mutateNextStage = true;
                eventBus.gotoStage2(this.mutateNextStage)
            })
            .catch((e) => {
                this.msg = "We are unable to proceed with this item at this time, do try again."
            })
        },
        uploadProceed(e) {
            // empty out the currently selected photos
            this.photosArr = []
            this.previewArr = []
            if(this.buildNewItemObj && this.buildNewItemObj.photos){
                this.buildNewItemObj.photos = []
            }
            // start image processing
            let images = e.target.files
            for(let x=0; x < images.length; x++){
                let reader = new FileReader()
                reader.readAsDataURL(images[x])
                reader.onload = e => {
                    this.previewImg = e.target.result;
                    let previewObj = {
                        path: this.previewImg,
                        main: this.previewArr.length == 0 ? true : false
                    }
                    this.previewArr.push(previewObj)
                    let photoObj = {
                        path: images,
                        main: this.photosArr.length == 0 ? true : false
                    }
                    this.photosArr.push(photoObj)
                }   
            }
        },
        removePhoto(photoId) {
            // query to see which photo becomes the next mainPhoto
            if(this.previewArr[photoId].main === true && this.photosArr[photoId].main === true){
                if(this.previewArr.length > 1 && this.photosArr.length > 1){
                    // if the last photo was clicked then minus 1 then set as main photo
                    if(this.previewArr.length === (photoId + 1) && this.photosArr.length === (photoId + 1)){ 
                        this.mainPhoto(photoId - 1) 
                    }
                    // else add 1 then set as main photo
                    else { 
                        this.mainPhoto(photoId + 1) 
                    }
                }
            }
            // remove photo from variable arrays
            this.previewArr.splice(photoId, 1)
            this.photosArr.splice(photoId, 1)
        },
        mainPhoto(photoId) {
            if(this.previewArr.length > 0){
                // set as main photo in previewArr
                for(let x=0; x < this.previewArr.length; x++){
                    this.previewArr[x].main = false
                }
                this.previewArr[photoId].main = true
            }
            if(this.photosArr.length > 0){
                // set as main photo in photosArr
                for(let x=0; x < this.photosArr.length; x++){
                    this.photosArr[x].main = false
                }
                this.photosArr[photoId].main = true
            }
        },
        cancelPosting() {
            this.destroyNewItemObj()
            .then(() => {
                this.$router.push({
                    name: 'profile'
                }).catch((e) => {})
            })
            .catch((e) => {})
        },
    },
    computed: {
        ...mapGetters(['user', 'preview', 'anewitem']),
        previewArrCheck() {
            if(this.previewArr.length > 0){
                return this.previewArr
            }
            return 3
        }
    },
    created() {
        // check if users account is verified
        if(!this.user.name || !this.user.userHandle){
            this.$router.push({
                name: 'profile'
            }).catch((e) => {})
        }
        if(this.preview && this.preview.length > 0){
            this.previewArr = this.preview
        }
        if(this.anewitem && this.anewitem.photos && this.anewitem.photos.length > 0){
            this.photosArr = this.anewitem.photos
        }
        this.footerFixed(false)
    }
}
</script>